/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreatePathologyDto } from './create-pathology-dto';
import { EnLevel } from './en-level';
import { EnUserAffectedSide } from './en-user-affected-side';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateUserPathologyDto
 */
export interface CreateUserPathologyDto {

    /**
     * @type {boolean}
     * @memberof CreateUserPathologyDto
     */
    comorbidity: boolean;

    /**
     * @type {boolean}
     * @memberof CreateUserPathologyDto
     */
    chronic: boolean;

    /**
     * @type {boolean}
     * @memberof CreateUserPathologyDto
     */
    acute: boolean;

    /**
     * @type {string}
     * @memberof CreateUserPathologyDto
     */
    start: string;

    /**
     * @type {EnUserAffectedSide}
     * @memberof CreateUserPathologyDto
     */
    affectedSide?: EnUserAffectedSide | null;

    /**
     * @type {EnLevel}
     * @memberof CreateUserPathologyDto
     */
    level?: EnLevel | null;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateUserPathologyDto
     */
    user?: JoinEntityDto | null;

    /**
     * @type {CreatePathologyDto | JoinEntityDto}
     * @memberof CreateUserPathologyDto
     */
    pathology: CreatePathologyDto | JoinEntityDto;
}
